import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},0.9)`} fill="none">
      <path
        d="M10.8201 100.58H60.48C60.48 100.58 67.62 79.8699 67.97 44.7699C68.32 9.6699 63.1301 1.41992 63.1301 1.41992H7.49005C7.49005 1.40992 -8.12994 52.49 10.8201 100.58Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
